<template>
  <div>
    <b-modal
      v-bind="$attrs"
      :name="name"
      :id="name"
      ref="modal"
      :ok-title="okLabel"
      >
      <template v-slot:header="{ close }">
        <slot name="modal-title">
          <h3 class="modal-title">{{ label }}</h3>
        </slot>
        <div v-if="$slots['header-center']" class="p-modal-header-center">
          <slot name="header-center" />
        </div>
        <b-close-button @click="close" />
      </template>
      <template v-if="$slots['modal-footer'] || $slots['footer']" v-slot:footer="scope">
        <slot name="modal-footer" v-bind="scope" />
        <slot name="footer" v-bind="scope" />
      </template>
      <template v-slot:default="scope">
        <slot v-bind="scope" />
      </template>
    </b-modal>

    <!-- Optional button to launch modal is included if a label is provided -->
    <b-button v-if="buttonLabel && smallButton"
                    :variant="buttonVariant"
                    size="sm"
                    class="py-0"
                    @click="onButtonClick"
                    :disabled="disableButton">{{ buttonLabel }}</b-button>
    <p-button v-else-if="buttonLabel" :is-busy='buttonBusy' :variant="buttonVariant" @click="onButtonClick" :disabled="disableButton" class="p-modal-icon-button">
      <b-icon-plus v-if="iconPlus"></b-icon-plus>{{ buttonLabel }}
    </p-button>

  </div>
</template>

<script>
import baseInputs from "@/components/mixins/BaseInputs";
import { registerModal, unregisterModal } from "@/plugins/bvModalShim";

export default {
  name: "p-modal",
  mixins: [baseInputs],
  emits: ['button-click'],
  props: {
    buttonLabel: String,
    // When set, the launch button emits button-click instead of opening the modal so the parent can decide whether opening is allowed
    guardButton: {
        type: Boolean,
        default: false
    },
    iconPlus:Boolean,
    okLabel: {
      type: String,
      default: "Ok"
    },
    disableButton: {
        type: Boolean,
        default: false
    },
    buttonBusy: {
        type: Boolean,
        default: false
    },
    smallButton: {
        type: Boolean,
        default: false
    },
    buttonVariant: {
        type: String,
        default: 'outline-primary'
    }
  },
  mounted() {
    if (this.name) {
      registerModal(this.name, this);
    }
  },
  beforeUnmount() {
    if (this.name) {
      unregisterModal(this.name);
    }
  },
  methods: {
    onButtonClick() {
      if (this.disableButton) return;
      if (this.guardButton) {
        this.$emit('button-click');
        return;
      }
      this.show();
    },
    show() {
      this.$refs.modal.show();
    },
    hide(){
      this.$refs.modal?.hide();
    }
  }
};
</script>

<style lang="scss">
/* Unscoped: BVN teleports modals to body, scoped CSS can't reach them */
.p-modal-icon-button button {
    display: inline-flex !important;
    align-items: center !important;
}
.p-modal-icon-button .bi {
    font-size: 1.3rem !important;
    margin-right: 4px;
    line-height: 1;
}
.modal-header {
  border-bottom: 0 none;
  position: relative;
}
/* Optional centered header content (e.g. a record subtitle). Absolutely positioned so the
   title (left) and close button (right) keep their normal places. */
.p-modal-header-center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  max-width: 55%;
  text-align: center;
}
.modal-header hr,
.modal-body > hr:first-child,
.modal-footer > hr:last-child {
  display: none;
}
.modal-footer {
  border-top: 0 none;
  position: relative;
  z-index: 2;
  background-color: #fff;
}
.modal-body {
  min-height: 150px;
  overflow-y: auto;
}
.modal.show .modal-content {
  resize: both;
  overflow: auto;
  min-width: 300px;
  min-height: 200px;
  max-width: 100vw;
  max-height: 95vh;
}
</style>
